export const SITE_URL = "independencedayind.maximquiz.com";
